import api from './axios'

export const getUserInfo = async() => {
  const res = await api.get("users/user-info")
  return res.data
}